import config from '../config';

export const openPicker = (token, type, onCancel) => {
    let resolvePicker;
    const pickerCallback = event => {
        if (event.action === 'cancel') {
            onCancel && onCancel();
        }

        if (event.action === 'picked') {
            resolvePicker({
                files: event.docs,
                token
            });
        }
    };

    const createPicker = () => {
        let picker = new window.google.picker.PickerBuilder();

        if (type === 'googleDocs') {
            const view = new window.google.picker.DocsView()
                .setParent('root')
                .setIncludeFolders(true)
                .setMode(window.google.picker.DocsViewMode.LIST);
            picker = picker.addView(view);
        } else {
            const view = new window.google.picker.DocsView()
                .setParent('root')
                .setIncludeFolders(true)
                .setMode(window.google.picker.DocsViewMode.LIST);
            picker = picker.addView(view);
        }
        picker = picker
            .enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED)
            .enableFeature(window.google.picker.Feature.NAV_HIDDEN)
            .hideTitleBar()
            .setOAuthToken(token)
            .setDeveloperKey(config.GOOGLE_CONFIG.API_KEY)
            .setCallback(pickerCallback)
            .build();
        picker.setVisible(true);
    }

    if (window.google && window.google.picker) {
        createPicker();
    } else {
        window.gapi.load('picker', createPicker);
    }

    return new Promise((resolve, reject) => {
        resolvePicker = resolve;
    });
}
